module.exports = __webpack_public_path__ + "static/jeanine-012-aee3ac31418231f211f3f68a18e8d5d5.jpg";